import i18next from 'i18next';
import * as Yup from 'yup';
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from '@studio/constants/library';
import { getMarkdownLimitLength } from '../getMarkdownLimitLength';

const useEditSavedVideoValidation = () => {
  return Yup.object({
    title: Yup.string()
      .required(i18next.t('common:errors.title.required'))
      .max(MAX_TITLE_LENGTH, () => i18next.t('pages:library.errors.title.maxLength')),
    description: Yup.string().test(
      'maxDescriptionLength',
      () => i18next.t('pages:library.errors.description.maxLength'),
      (value) => getMarkdownLimitLength(value ?? '') <= MAX_DESCRIPTION_LENGTH
    ),
    airDate: Yup.string().required(i18next.t('pages:library.dateCreatedRequired')),
    airTime: Yup.string().required(i18next.t('pages:library.dateCreatedRequired')),
    tags: Yup.array(
      Yup.object({
        label: Yup.string(),
        value: Yup.string().max(150, i18next.t('pages:library.errors.tags.maxLength')),
      })
    ),
  });
};

export default useEditSavedVideoValidation;
